/**
 * The day the diary was last left on — the nutrition spec, The diary: left for another
 * destination and come back to, it stands on the day it was left on, and a launch opens it
 * on today. Held for as long as the app is open, and nowhere else.
 */
let lastLeftOn: string | null = null

/** Whatever names the day, told when it moves — the way to the diary follows the diary. */
const listeners = new Set<() => void>()

/** The diary is on this day now. */
export function keepDiaryDay(day: string | null): void {
  if (day === lastLeftOn) {
    return
  }
  lastLeftOn = day
  for (const listener of listeners) {
    listener()
  }
}

/** Told whenever the diary moves its day; hands back the way to stop being told. */
export function onDiaryDay(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** The day the diary was last on, today included; null where it has not been opened. */
export function diaryDayLastOn(): string | null {
  return lastLeftOn
}

/** The day the diary was last on, where that is not today; null where it opens on today. */
export function diaryDayKept(today: string): string | null {
  return lastLeftOn === null || lastLeftOn === today ? null : lastLeftOn
}

/** Back to today, for one test not to leave the next its day. */
export function forgetDiaryDay(): void {
  keepDiaryDay(null)
}
